import { render, staticRenderFns } from "./ComplaintDetail.vue?vue&type=template&id=7e8d9534&scoped=true"
import script from "./ComplaintDetail.vue?vue&type=script&lang=js"
export * from "./ComplaintDetail.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetail.vue?vue&type=style&index=0&id=7e8d9534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d9534",
  null
  
)

export default component.exports